

















































import UUIFComponent from '@/shared/uuifComponent';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { InfoState } from '@/core';
import { required, helpers } from 'vuelidate/lib/validators';
import RegexValidators from '@/shared/regex-validators';

const subscriptionCodeCheck = helpers.regex('subscriptionCodeRegex', new RegExp(RegexValidators.subscriptionCode));

const cssPrefix = 'verify-subscription-code-dialog';

@Component({
  components: {
    ...UUIFComponent,
  },
  validations: {
    subscriptionCode: { required, subscriptionCodeCheck },
  },
})
export default class VerifySubscriptionCodeDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: Boolean, default: false })
  isShowModal: Boolean;

  @Prop({ type: String, default: '' })
  emailAddress: String;

  subscriptionCode: String = '';
  invalidSubscriptionCodeError: boolean = false;
  emptySubscriptionCodeError: boolean = false;

  get isEmptySubscriptionCode(): boolean {
    return this.$v!.subscriptionCode!.$invalid &&
    this.$v!.subscriptionCode!.$dirty &&
    !this.$v!.subscriptionCode!.required;
  }

  get IsInvalidSubscriptionCode(): boolean {
    return this.$v!.subscriptionCode!.$invalid &&
    this.$v!.subscriptionCode!.$dirty &&
    !this.$v!.subscriptionCode!.subscriptionCodeCheck &&
    this.$v!.subscriptionCode!.required;
  }

  public update() {
    this.$v.subscriptionCode?.$touch();
    if (this.isEmptySubscriptionCode || this.IsInvalidSubscriptionCode) {
      return;
    }
    const request = {
      emailAddress: this.emailAddress,
      subscriptionCode: this.subscriptionCode,
    };
    this.$store
      .dispatch('verifySubscriptionCode', request)
      .then((res: any) => {
        if (res.msgCode === 'MSWAPP:SUCCESS') {
          this.showMessage('success', res.msgDesc || 'Successfully updated');
          this.closeDialog(true);
        } else {
          this.showMessage('failed', res.msgDesc || 'Something went wrong');
        }
      })
      .catch((err: Error) => {
        console.error(err);
        this.showMessage('failed', 'Something went wrong');
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  showMessage(infoType: string, infoMsg: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }

  closeDialog(isReLogin: boolean = false) {
    this.$emit('request-close', isReLogin);
  }
}
